import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ChevronRightIcon } from "@heroicons/vue/24/solid";

export default /*#__PURE__*/_defineComponent({
  __name: 'BadgeComponent',
  props: {
    color: {
        type: String,
        default: "black",
    },
    text: {
        type: String,
        required: true,
    },
    textColor: {
        type: String,
        default: "white",
    },
    forwardIcon: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["rounded-3xl px-3 py-1 inline-flex flex items-center justify-center space-x-2", __props.color])
  }, [
    _renderSlot(_ctx.$slots, "leftIcon"),
    _createElementVNode("p", {
      class: _normalizeClass(["text-sm font-semibold", __props.textColor])
    }, _toDisplayString(__props.text), 3),
    _renderSlot(_ctx.$slots, "rightIcon"),
    (__props.forwardIcon)
      ? (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
          key: 0,
          class: _normalizeClass(["w-4 h-4", __props.textColor])
        }, null, 8, ["class"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})